import React, { useState,useEffect } from 'react'
import axios from 'axios';

import FlyCheckDetail from "./FlyCheckDetail";
import { escapeHtml } from '../../../components/common/Common';

const FlyChecks = ({varVTIndex,varFlyChecksList,GetFlyOptionsList}) => {

  const [varChecksInfo,setChecksInfo] = useState({});
  const [varShowSubChecks,setShowSubChecks] = useState(false);

  const [varStudysList,setStudysList] = useState([]);

  //최초실행부
  useEffect(() => {
    let studys = [];
    for(var i=1; i <= 12; i++) {
      studys.push(i);
    }
    setStudysList(studys);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //추가/편집
  const onEditChecksHandler = (e,vtc_idx) => {
    e.preventDefault();
    if(vtc_idx === 0) {
      const newItem = {vtc_idx:0,vt_idx:varVTIndex,vts_idx:1,vtc_chapter:1,vtc_purpose_direct:'',vtc_purpose_indirect:'',vtc_next_class:'',vtc_status:1};
      setChecksInfo(newItem);
    } else {
      const checksData = varFlyChecksList.find(el=>el.vtc_idx === vtc_idx);
      setChecksInfo(checksData);
    }
    setShowSubChecks(true);
  }

  //입력값 조정
  const onChangeInputHandler = (e) => {
    const { name,value } = e.currentTarget;
    if(name === "vtc_chapter" || name === "vts_idx") {
      setChecksInfo({...varChecksInfo,[name]:Number(value)});
    } else if(name === "vtc_purpose_indirect" || name === "vtc_next_class") {
      setChecksInfo({...varChecksInfo,[name]:escapeHtml(value)});
    } else {
      setChecksInfo({...varChecksInfo,[name]:value});
    }
  }

  //평가항목 사용유무
  const onToggleChecksHandler = async(e,vtc_idx,vtc_status) => {
    let sprompt = '선택된 평가항목을 삭제합니까?';
    if(vtc_status === 1) sprompt = "선택된 평가항목을 사용합니까?";
    if(!window.confirm(sprompt)) return false;

    const sendData = {vtc_idx:vtc_idx,vtc_status:vtc_status};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_toggle_fly_checks_status`, sendData).then((res) => {
      console.log(res.data);
      if (res.data.retvalue === 1) {
        GetFlyOptionsList();
      } else {
        alert(res.data.message);
      }
    });   
  }
  
  //평가항목 저장
  const onUpdateChecksHandler = async(e)  => {
    if(!window.confirm('저장합니까?')) return false;
    setShowSubChecks(false)
    const sendData = {dataInfo:varChecksInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_fly_checks_status`, sendData).then((res) => {
      console.log(res.data);
      if (res.data.retvalue === 1) {
        GetFlyOptionsList();
      } else {
        alert(res.data.message);
      }
    });   
  }

  return (
    <>
      <div className="main-box">
        <div className="btn-right">
          <button className="btn-danger" onClick={e=>onEditChecksHandler(e,0)}>추가</button>
        </div>
        <table cellPadding="5" cellSpacing="0" border="1" className="write">
          <colgroup><col width="5%"/><col width="5%"/><col width="5%"/><col width="15%"/><col width="25%"/><col width="25%"/><col width="10%"/><col width="10%"/></colgroup>
          <thead>
            <tr><th>번호</th><th>단계</th><th>챕터</th><th>직접목적</th><th>간접목적</th><th>다음수업</th><th>사용</th><th>관리</th></tr>
          </thead>
          <tbody>
            {varFlyChecksList.map((checks,i) => (
              <tr key={'checks_'+i}>
                <td>{i+1}</td>
                <td>{checks.vts_idx}</td>
                <td>{checks.vtc_chapter}</td>
                <td>{checks.vtc_purpose_direct}</td>
                <td>{checks.vtc_purpose_indirect}</td>
                <td>{checks.vtc_next_class}</td>
                <td>{checks.vtc_status===1?"사용":"사용중지"}</td>
                <td>
                  <button onClick={e=>onEditChecksHandler(e,checks.vtc_idx)} style={{width:"70px"}} className="btn line black">편집</button>
                  {checks.vtc_status===1?
                    <button onClick={e=>onToggleChecksHandler(e,checks.vtc_idx,0)} style={{width:"90px"}} className="btn line black">사용중지</button>
                  :
                    <button onClick={e=>onToggleChecksHandler(e,checks.vtc_idx,1)} style={{width:"70px"}} className="btn line black">사용</button>
                  }
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <FlyCheckDetail varShowSubChecks={varShowSubChecks} setShowSubChecks={setShowSubChecks} varStudysList={varStudysList} 
                    varChecksInfo={varChecksInfo} onChangeInputHandler={onChangeInputHandler} onUpdateChecksHandler={onUpdateChecksHandler}/>
    </>
  )
}
export default FlyChecks;